export default {
    LANGUAGES: {
        VI: 'VI',
        JA: 'JA',
        EN: 'EN'
    }
};
